import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17dcdef0")

_pushScopeId("data-v-17dcdef0")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = { class: "versionGeneration" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("对比")
const _hoisted_5 = { style: {"display":"flex","align-items":"center","justify-content":"center","margin-top":"20px","position":"relative"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 导出总结报告")
const _hoisted_7 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  id: "test",
  style: {"width":"48%"}
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "versionGeneration" }
const _hoisted_12 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("对比")
const _hoisted_14 = { style: {"display":"flex","align-items":"center","justify-content":"center","margin-top":"20px","position":"relative"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 导出总结报告")
const _hoisted_16 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { style: {"width":"48%"} }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { style: {"display":"flex"} }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "el-icon-document" }, null, -1)
const _hoisted_22 = { class: "down_nav_list" }
const _hoisted_23 = {
  key: 0,
  class: "el-icon-d-arrow-left"
}
const _hoisted_24 = {
  key: 1,
  class: "el-icon-d-arrow-right"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_tabs, {
                  onTabClick: _ctx.tabsChange,
                  type: "card",
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.activeName = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_tab_pane, {
                      name: "first",
                      label: "对象内存"
                    }, {
                      default: _withId(() => [
                        _withDirectives(_createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_2, [
                              _createVNode("div", _hoisted_3, [
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.MemoryChange('obj', 'version'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_version,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selected_table_version = $event)),
                                      placeholder: "版本号"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.MemoryChange('obj', 'device'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_device,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selected_table_device = $event)),
                                      placeholder: "机型"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (group) => {
                                          return (_openBlock(), _createBlock(_component_el_option_group, {
                                            key: group.label,
                                            label: group.label
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.MemoryChange('obj', 'scene'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_scene,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selected_table_scene = $event)),
                                      placeholder: "场景"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.scene_id,
                                            label: item.chinese,
                                            value: item.scene_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.MemoryChange('obj', 'inside_scene', '1'))),
                                      size: "mini",
                                      modelValue: _ctx.inside_obj_scene,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.inside_obj_scene = $event)),
                                      placeholder: "局内场景"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deep_scene_obj_options, (item, i) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: i,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      onClick: _ctx.contrastBtn,
                                      type: "primary"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.MemoryChange('obj1', 'version'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_version1,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selected_table_version1 = $event)),
                                      placeholder: "版本号"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.MemoryChange('obj1', 'device'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_device1,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selected_table_device1 = $event)),
                                      placeholder: "机型"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options1, (group) => {
                                          return (_openBlock(), _createBlock(_component_el_option_group, {
                                            key: group.label,
                                            label: group.label
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.MemoryChange('obj1', 'scene'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_scene1,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selected_table_scene1 = $event)),
                                      placeholder: "场景"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options1, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.scene_id,
                                            label: item.chinese,
                                            value: item.scene_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.MemoryChange('obj1', 'inside_scene', '1'))),
                                      size: "mini",
                                      modelValue: _ctx.inside_obj_scene1,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.inside_obj_scene1 = $event)),
                                      placeholder: "局内场景"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deep_scene_obj_old_options, (item, i) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: i,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode("div", _hoisted_5, [
                                _createVNode(_component_el_input, {
                                  size: "mini",
                                  modelValue: _ctx.inputValue,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.inputValue = $event)),
                                  class: _ctx.inputColor,
                                  onChange: _ctx.submit,
                                  placeholder: "请输入文本",
                                  style: {"width":"300px"}
                                }, null, 8, ["modelValue", "class", "onChange"]),
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "primary",
                                  style: {"width":"100px","position":"absolute","right":"0"}
                                }, {
                                  default: _withId(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createVNode("div", _hoisted_7, [
                              _createVNode("div", {
                                style: 'width:' + _ctx.tableWidth
                              }, [
                                _withDirectives(_createVNode(_component_el_table, {
                                  class: "scrollTable",
                                  "row-style": _ctx.tableRowClassName,
                                  size: "small",
                                  "header-cell-style": {
                        background: '#F5F6FA',
                        color: '#B5B5B5',
                        border: '0',
                        padding: '1px,0',
                        height: '10px',
                      },
                                  data: _ctx.leftAllTable,
                                  style: {"width":"100%"},
                                  "row-key": "id",
                                  "expand-row-keys": _ctx.expandRowKeys,
                                  onExpandChange: _ctx.handleExpandChange,
                                  ref: "leftTable"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        "show-overflow-tooltip": true,
                                        sortable: "fasle",
                                        key: item.label,
                                        "min-width": item.label == '名称' ? '67%' : '16.5%',
                                        index: index,
                                        label: item.label
                                      }, {
                                        default: _withId((scope) => [
                                          (item.prop != 'size')
                                            ? (_openBlock(), _createBlock("span", {
                                                key: 0,
                                                id: scope.row.id
                                              }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                            : (_openBlock(), _createBlock("span", _hoisted_8, [
                                                _createTextVNode(_toDisplayString(_ctx.sizeCompany(String(scope.row.size))), 1),
                                                _createVNode("span", {
                                                  style: 
                                'color:' + _ctx.deviationColor(scope.row.deviation)
                              
                                                }, _toDisplayString(_ctx.deviation(String(scope.row.deviation))), 5)
                                              ]))
                                        ]),
                                        _: 2
                                      }, 1032, ["min-width", "index", "label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["row-style", "data", "expand-row-keys", "onExpandChange"]), [
                                  [_directive_loading, _ctx.objLoading]
                                ])
                              ], 4),
                              _withDirectives(_createVNode("div", _hoisted_9, [
                                _withDirectives(_createVNode(_component_el_table, {
                                  "row-style": _ctx.tableRowClassName1,
                                  size: "small",
                                  "expand-row-keys": _ctx.expandRowKeys,
                                  onExpandChange: _ctx.handleExpandChange1,
                                  "header-cell-style": {
                        background: '#F5F6FA',
                        color: '#B5B5B5',
                        border: '0',
                        padding: '1px,0',
                        height: '10px',
                      },
                                  data: _ctx.rightAllTable,
                                  style: {"width":"100%"},
                                  "row-key": "id",
                                  ref: "table"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        "show-overflow-tooltip": true,
                                        sortable: "fasle",
                                        key: item.label,
                                        "min-width": item.label == '名称' ? '67%' : '16.5%',
                                        index: index,
                                        label: item.label
                                      }, {
                                        default: _withId((scope) => [
                                          (item.prop != 'size')
                                            ? (_openBlock(), _createBlock("span", {
                                                key: 0,
                                                id: scope.row.id + 1
                                              }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                            : (_openBlock(), _createBlock("span", _hoisted_10, [
                                                _createTextVNode(_toDisplayString(_ctx.sizeCompany(String(scope.row.size))), 1),
                                                _createVNode("span", {
                                                  style: 
                                'color:' + _ctx.deviationColor(scope.row.deviation)
                              
                                                }, _toDisplayString(_ctx.deviation(String(scope.row.deviation))), 5)
                                              ]))
                                        ]),
                                        _: 2
                                      }, 1032, ["min-width", "index", "label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["row-style", "expand-row-keys", "onExpandChange", "data"]), [
                                  [_directive_loading, _ctx.objLoading]
                                ])
                              ], 512), [
                                [_vShow, _ctx.btnTrue]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      name: "second",
                      label: "音频内存"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_11, [
                              _createVNode("div", _hoisted_12, [
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.MemoryChange('vedio', 'version'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_version_vedio,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.selected_table_version_vedio = $event)),
                                      placeholder: "版本号"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options_vedio, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.MemoryChange('vedio', 'device'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_device_vedio,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.selected_table_device_vedio = $event)),
                                      placeholder: "机型"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options_vedio, (group) => {
                                          return (_openBlock(), _createBlock(_component_el_option_group, {
                                            key: group.label,
                                            label: group.label
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.MemoryChange('vedio', 'scene'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_scene_vedio,
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.selected_table_scene_vedio = $event)),
                                      placeholder: "场景"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options_vedio, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.scene_id,
                                            label: item.chinese,
                                            value: item.scene_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.MemoryChange('vedio', 'inside_scene', '1'))),
                                      size: "mini",
                                      modelValue: _ctx.inside_obj_scene_vedio,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.inside_obj_scene_vedio = $event)),
                                      placeholder: "局内场景"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deep_scene_obj_options_vedio, (item, i) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: i,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      onClick: _ctx.contrastBtn1,
                                      type: "primary"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_13
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.MemoryChange('vedio1', 'version'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_version1_vedio,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.selected_table_version1_vedio = $event)),
                                      placeholder: "版本号"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options_vedio, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.MemoryChange('vedio1', 'device'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_device1_vedio,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.selected_table_device1_vedio = $event)),
                                      placeholder: "机型"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options1_vedio, (group) => {
                                          return (_openBlock(), _createBlock(_component_el_option_group, {
                                            key: group.label,
                                            label: group.label
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.MemoryChange('vedio1', 'scene'))),
                                      size: "mini",
                                      modelValue: _ctx.selected_table_scene1_vedio,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.selected_table_scene1_vedio = $event)),
                                      placeholder: "场景"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options1_vedio, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.scene_id,
                                            label: item.chinese,
                                            value: item.scene_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.MemoryChange('vedio1', 'inside_scene', '1'))),
                                      size: "mini",
                                      modelValue: _ctx.inside_obj_scene1_vedio,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.inside_obj_scene1_vedio = $event)),
                                      placeholder: "局内场景"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deep_scene_obj_old_options_vedio, (item, i) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: i,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode("div", _hoisted_14, [
                                _createVNode(_component_el_input, {
                                  size: "mini",
                                  modelValue: _ctx.inputValue1,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.inputValue1 = $event)),
                                  class: _ctx.inputColor1,
                                  onChange: _ctx.submit1,
                                  placeholder: "请输入文本",
                                  style: {"width":"300px"}
                                }, null, 8, ["modelValue", "class", "onChange"]),
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "primary",
                                  style: {"width":"100px","position":"absolute","right":"0"}
                                }, {
                                  default: _withId(() => [
                                    _hoisted_15
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createVNode("div", _hoisted_16, [
                              _createVNode("div", {
                                style: 'width:' + _ctx.tableWidth
                              }, [
                                _withDirectives(_createVNode(_component_el_table, {
                                  size: "small",
                                  onExpandChange: _ctx.handleExpandChange2,
                                  "row-style": _ctx.tableRowClassName,
                                  "header-cell-style": {
                        background: '#F5F6FA',
                        color: '#B5B5B5',
                        border: '0',
                        padding: '1px,0',
                        height: '10px',
                      },
                                  data: _ctx.leftAllTableAudio,
                                  style: {"width":"100%"},
                                  "row-key": "id",
                                  ref: "leftTable1"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        sortable: "fasle",
                                        "show-overflow-tooltip": true,
                                        key: item.label,
                                        "min-width": item.label == '名称' ? '67%' : '16.5%',
                                        index: index,
                                        label: item.label
                                      }, {
                                        default: _withId((scope) => [
                                          (item.prop != 'size')
                                            ? (_openBlock(), _createBlock("span", {
                                                key: 0,
                                                id: scope.row.id
                                              }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                            : (_openBlock(), _createBlock("span", _hoisted_17, [
                                                _createTextVNode(_toDisplayString(_ctx.sizeCompany(String(scope.row.size))), 1),
                                                _createVNode("span", {
                                                  style: 
                                'color:' + _ctx.deviationColor(scope.row.deviation)
                              
                                                }, _toDisplayString(_ctx.deviation(String(scope.row.deviation))), 5)
                                              ]))
                                        ]),
                                        _: 2
                                      }, 1032, ["min-width", "index", "label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onExpandChange", "row-style", "data"]), [
                                  [_directive_loading, _ctx.vedioLoading]
                                ])
                              ], 4),
                              _withDirectives(_createVNode("div", _hoisted_18, [
                                _withDirectives(_createVNode(_component_el_table, {
                                  onExpandChange: _ctx.handleExpandChange3,
                                  size: "small",
                                  "row-style": _ctx.tableRowClassName1,
                                  "header-cell-style": {
                        background: '#F5F6FA',
                        color: '#B5B5B5',
                        border: '0',
                        padding: '1px,0',
                        height: '10px',
                      },
                                  data: _ctx.rightAllTableAudio,
                                  style: {"width":"100%"},
                                  "row-key": "id",
                                  ref: "table1"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_table_column, {
                                        "show-overflow-tooltip": true,
                                        sortable: "fasle",
                                        key: item.label,
                                        "min-width": item.label == '名称' ? '67%' : '16.5%',
                                        index: index,
                                        label: item.label
                                      }, {
                                        default: _withId((scope) => [
                                          (item.prop != 'size')
                                            ? (_openBlock(), _createBlock("span", {
                                                key: 0,
                                                id: scope.row.id + 1
                                              }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                            : (_openBlock(), _createBlock("span", _hoisted_19, [
                                                _createTextVNode(_toDisplayString(_ctx.sizeCompany(String(scope.row.size))), 1),
                                                _createVNode("span", {
                                                  style: 
                                'color:' + _ctx.deviationColor(scope.row.deviation)
                              
                                                }, _toDisplayString(_ctx.deviation(String(scope.row.deviation))), 5)
                                              ]))
                                        ]),
                                        _: 2
                                      }, 1032, ["min-width", "index", "label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onExpandChange", "row-style", "data"]), [
                                  [_directive_loading, _ctx.vedioLoading]
                                ])
                              ], 512), [
                                [_vShow, _ctx.btnTrue]
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      name: "third",
                      label: "memreport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_20, [
                              _createVNode(_component_el_form_item, {
                                class: "iTemWidth",
                                style: {"margin-right":"20px"}
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.versionChange,
                                    size: "mini",
                                    modelValue: _ctx.DeepSceneOptionsVersion,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.DeepSceneOptionsVersion = $event)),
                                    placeholder: "版本"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.DeepSceneOptions.version, (item, i) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: i,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                class: "iTemWidth",
                                style: {"margin-right":"20px"}
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    size: "mini",
                                    onChange: _ctx.thirdChange,
                                    modelValue: _ctx.DeepSceneOptionsDevice,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.DeepSceneOptionsDevice = $event)),
                                    placeholder: "机型"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options3, (group) => {
                                        return (_openBlock(), _createBlock(_component_el_option_group, {
                                          key: group.label,
                                          label: group.label
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { class: "iTemWidth" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    size: "mini",
                                    onChange: _ctx.fourthChange,
                                    modelValue: _ctx.DeepSceneOptionsScene,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.DeepSceneOptionsScene = $event)),
                                    placeholder: "场景"
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options_change, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.chinese,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_el_table, {
                              "cell-style": { padding: '12px 0px' },
                              data: _ctx.deepSceneRport,
                              style: {"width":"100%"}
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  style: {"padding":"0px"},
                                  prop: "file_name",
                                  label: "文件名"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode(_component_el_tag, {
                                      type: "info",
                                      size: "medium",
                                      effect: "plain"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_21,
                                        _createTextVNode(" " + _toDisplayString(scope.row.file_name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "time",
                                  label: "上传时间"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "file_path",
                                  label: "下载"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("a", {
                                      href: scope.row.file_path,
                                      class: "ml-3",
                                      download: "",
                                      style: {"color":"#409eff","cursor":"pointer"}
                                    }, " 下载 ", 8, ["href"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onTabClick", "modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_22, [
            _createVNode("button", {
              onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.rightBtn && _ctx.rightBtn(...args))),
              class: "gallery_btn"
            }, [
              (_ctx.btnTrue)
                ? (_openBlock(), _createBlock("i", _hoisted_23))
                : (_openBlock(), _createBlock("i", _hoisted_24))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})